import {
  Utils,
  Templates,
  Formio,
  Components,
  FormRenderer,
  FormBuilder,
} from "@qoala-engineering/vue-formio";

import Vue from "vue";

Vue.component("FormRenderer", FormRenderer);
Vue.component("FormBuilder", FormBuilder);

export { FormRenderer, FormBuilder, Components, Formio, Utils, Templates };
